  <div class="dashboard-container">
    <!-- Filters and Stats Row -->
    <div class="filters">
      <h2 class="m-0 font-size-22">Gamification board</h2>
      <div class="category-filter filter-div mr-22">
        <app-multi-select-dropdown
          #dropdownRef
          [placeHolderTitle]="'Category'"
          [dropdownList]="dropDownCategories"
          [dropdownSettings]="categoryDropdownSettings"
          [selectedItems]="selectedCat"
          [tempSelectedItems]="tempSelectedItems"
          [clearfilter]="clearfilter"
          (onSelectionChange)="onChangeCategory($event)"
          (click)="onDropDownOpen()"
          (onApply)="onCategoryApply($event)"
          (onReset)="onCategoryReset()"
          (onSelect)="onItemSelect($event, dropDownCategories)"
          (onDeSelect)="onItemDeSelect($event, dropDownCategories)"
        ></app-multi-select-dropdown>
      </div>
    </div>
    <!--  -->
    <div class="snapshot-container">
      <!-- flex-direction: row; -->
      <div
        class="column"
        style="
          display: flex;
          flex-wrap: wrap;
          gap: 2px;
          width: fit-content;
          border-radius: 8px;
          background-color: #fff;
          border: solid 1px #ececf4;
          justify-content: space-between;
        "
      >
        <ng-container *ngFor="let x of statCards; let isLast = last">
          <div
            class="stat-card"
            style="
              padding: 5px;
              height: 61px;
              display: flex;
              gap: 5px;
              width: fit-content;
            "
          >
            <!-- background-color: red; -->
            <div class="stat-title">
              {{ x.title }}<img src="/assets/icons/Badge.svg" alt="badge" [matTooltip]="x?.tooltip || ''" *ngIf="x.title != 'Total Categories'" style="cursor: pointer;"/>
            </div>
            <div class="stat-value">{{ x.value }}</div>
          </div>
          <div
            *ngIf="!isLast"
            style="padding: 6px; background-color: transparent"
            class="bordered-div"
          ></div>
        </ng-container>
      </div>

      <div
        class="column"
        style="
          display: flex;
          flex-wrap: wrap;
          gap: 2px;
          width: fit-content;
          border-radius: 8px;
          background-color: #fff;
          border: solid 1px #ececf4;
          justify-content: space-between;
        "
      >
        <ng-container *ngFor="let x of rightCards; let isLast = last;let i = index;">
          <div
            class="stat-card"
            style="
              padding: 5px;
              height: 61px;
              display: flex;
              gap: 5px;
              width: fit-content;
            "
          >
            <!-- background-color: red; -->
            <div class="stat-title">
              {{ x.title }}

              <img src="/assets/icons/Badge.svg" alt="badge" [matTooltip]="x?.tooltip || ''" style="cursor: pointer;"/>
            </div>
            <div class="stat-value">{{ x.value }} 
              @if(i==0){<span style="font-size: 14px;color: #454554;" >Runs</span>}
              @if(i==3){<span style="font-size: 14px;color: #454554;" >Out of 5</span>}
            </div>
          </div>
          <div
            *ngIf="!isLast"
            style="padding: 6px; background-color: transparent"
            class="bordered-div"
          ></div>
        </ng-container>
      </div>
    </div>
    <div class="date-selection">
      <span class="Note-Data">Note: Data displayed on the page reflects the current active data available for the selected date range.</span>
        <div style="display: flex;">
        <input
          class="input-calander"
          [(ngModel)]="value"
        />
        <span class="cal-span" (click)="openDateSelection()">
          <img alt="calander-icon" src="/assets/icons/calander-icon.svg" />
        </span>
      </div>
    </div>

    <!-- Top Sections -->
    <div class="tables-grid">
      <mat-card class="data-table-card" *ngIf="mostUsedPromptsData?.length">
        <div class="table-header">
          <span class="table-title">Top 5 most used prompts
            <img src="assets/gamification-images/info-badge.svg" alt="info badge" class="info-badge" matTooltip="Prompts with the most runs since the platform launch" style="cursor: pointer;"/></span>
          <button mat-button color="primary" class="button-mostUsed" (click)="viewAllMostUsedPrompts($event)">View All</button>
        </div>
        
        <table mat-table [dataSource]="dataSource" aria-label="most used prompts data">
          <ng-container matColumnDef="prompt_name">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;">Prompt Title</th>
            <td mat-cell *matCellDef="let row">
              <div class="ellipsis-text" title="{{row?.prompt_name}}">{{ row?.prompt_name }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="usage">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;">Usage <span style="font-size: 12px; font-weight: 400;">(Runs)</span></th>
            <td mat-cell *matCellDef="let row">{{ row?.usage }}</td>
          </ng-container>
          <ng-container matColumnDef="consumers">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;">Users</th>
            <td mat-cell *matCellDef="let row">{{ row?.consumers }}</td>
          </ng-container>
          <ng-container matColumnDef="average_rating">
            <th class="text-ellipsis" title="Quality Rating" mat-header-cell *matHeaderCellDef style="width: 20%;">Quality Rating</th>
            <td mat-cell *matCellDef="let row">
              <div style="display: flex; align-items: center; gap: 4px;">
                <img src="assets/gamification-images/star_half.svg" alt="half star"/> {{ row?.average_rating }}
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </table>
        <!-- } -->
      </mat-card>

      <mat-card class="data-table-card" *ngIf="mostTrendingPromptsData?.length">
        <div class="table-header">
          <span class="table-title">Top 5 most trending prompts
            <img src="assets/gamification-images/info-badge.svg" alt="info badge" class="info-badge" matTooltip="Prompts with the most runs during the selected date range" style="cursor: pointer;"/></span>
          <button mat-button color="primary" class="button-trending" (click)="viewAllTrendingPrompts($event)">View All</button>
        </div>
        <table mat-table [dataSource]="trendingPromptsDataSource" aria-label="trending prompts data">
          <ng-container matColumnDef="prompt_name">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;">Prompt Title</th>
            <td mat-cell *matCellDef="let row">
              <div class="ellipsis-text" title="{{row?.prompt_name}}">{{ row?.prompt_name }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="usage">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;">Usage <span style="font-size: 12px; font-weight: 400;">(Runs)</span></th>
            <td mat-cell *matCellDef="let row">{{ row?.usage }}</td>
          </ng-container>
          <ng-container matColumnDef="consumers">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;">Users</th>
            <td mat-cell *matCellDef="let row">{{ row?.consumers }}</td>
          </ng-container>
          <ng-container matColumnDef="average_rating">
            <th class="text-ellipsis" title="Quality Rating" mat-header-cell *matHeaderCellDef style="width: 20%;">Quality Rating</th>
            <td mat-cell *matCellDef="let row">
              <div style="display: flex; align-items: center; gap: 4px;">
                <img src="assets/gamification-images/star_half.svg" alt="half star"/> {{ row?.average_rating }}
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </table>
      </mat-card>

      <mat-card class="data-table-card" *ngIf="powerUsersData?.length">
        <div class="table-header">
          <span class="table-title">Top 5 Power Users</span>
          <button mat-button color="primary" class="button-powerUsers" (click)="viewAllPowerUsers($event)">View All</button>
        </div>
        <!-- {{ table.dataSource | json }}
        {{ table.columns | json }} -->
        <!-- @if(table && table.dataSource && table.columns){ -->
        <table mat-table [dataSource]="powerUsersDataSource" aria-label="power users data">
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;">Name</th>
            <td mat-cell *matCellDef="let row">
              <div class="ellipsis-text" title="{{ row?.username }}">{{ row?.username }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;">Role
              <img src="assets/gamification-images/info-badge.svg" alt="info badge" class="info-badge" matTooltip="Latest assigned role of the user" style="cursor: pointer;"/>
            </th>
            <td mat-cell *matCellDef="let row">{{ row?.role }}</td>
          </ng-container>
          <ng-container matColumnDef="prompt_activity">
            <th class="text-ellipsis" title="Prompt Activity" mat-header-cell *matHeaderCellDef style="width: 20%;">Prompt Activity</th>
            <td mat-cell *matCellDef="let row">
              <div class="single-line-ellipsis" [title]="row?.parsedActivity?.first" *ngIf="row?.parsedActivity?.first">
                {{ row?.parsedActivity?.first }}
              </div>
              <div class="second-line" *ngIf="row?.parsedActivity?.second">
                <span class="single-line-ellipsis" [title]="row?.parsedActivity?.second">{{ row?.parsedActivity?.second }}</span>
                <span 
                  *ngIf="row?.parsedActivity?.rest?.length"
                  class="more-count"
                  style="white-space: nowrap;"
                  [matTooltip]="row?.parsedActivity?.rest?.join(', ')">
                  + {{ row?.parsedActivity?.rest?.length }}
                </span>
              </div>
            </td>
            
          </ng-container>
          <ng-container matColumnDef="points">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;">Points
              <img src="assets/gamification-images/info-badge.svg" alt="info badge" class="info-badge" matTooltip="Total points earned by the application user based on their prompt activity. (publishing prompts, prompt approval/rejection, prompt execution and Rating/feedback)" style="cursor: pointer;"/>
            </th>
            <td mat-cell *matCellDef="let row">{{ row?.points }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedPowerUsersColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedPowerUsersColumns;">
        </table>
        <!-- } -->
      </mat-card>
    
      <mat-card class="data-table-card" *ngIf="topCategory?.length && this.isCategory">
        <div class="table-header">
          <span class="table-title">Top 5 Categories</span>
          <button mat-button color="primary" class="button-topCategories" (click)="viewTopCategories($event)">View All</button>
        </div>
        <table mat-table [dataSource]="topCategories" aria-label="top categories">
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;">Category</th>
            <td mat-cell *matCellDef="let row" title="{{ row?.category }}">{{ row?.category }}</td>
          </ng-container>
          <ng-container matColumnDef="prompts">
            <th mat-header-cell *matHeaderCellDef style="width: 30%;">Promtps</th>
            <td mat-cell *matCellDef="let row">{{ row?.prompts }}</td>
          </ng-container>
          <ng-container matColumnDef="users">
            <th mat-header-cell  *matHeaderCellDef style="width: 20%; cursor: pointer;" title="Users">Users</th>
            <td mat-cell *matCellDef="let row">{{ row?.users }}</td>
          </ng-container>
          <ng-container matColumnDef="usage">
            <th mat-header-cell  *matHeaderCellDef style="width: 20%; cursor: pointer;" title="Usage (Runs)">Usage <span style="font-size: 12px; font-weight: 400;">(Runs)</span></th>
            <td mat-cell *matCellDef="let row">{{ row?.usage }}</td>
          </ng-container>
          <ng-container matColumnDef="average_time_saved">
            <th class="text-ellipsis" title="Time Saving Est."  mat-header-cell *matHeaderCellDef style="width: 20%;">Time Saving Est.</th>
            <td mat-cell *matCellDef="let row">{{ formatTimeString(row?.average_time_saved) }}</td>
          </ng-container>
          <ng-container matColumnDef="average_rating">
            <th class="text-ellipsis" title="Avg. Rating"  mat-header-cell *matHeaderCellDef style="width: 20%;">Avg. Rating</th>
            <td mat-cell *matCellDef="let row">
              <div style="display: flex; align-items: center; gap: 4px;">
                <img src="assets/gamification-images/star_half.svg" alt="half star"/> {{ row?.average_rating }}
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsCategories"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsCategories;">
        </table>
      </mat-card>

      <mat-card class="data-table-card" *ngIf="curatorListData?.length">
        <div class="table-header">
          <span class="table-title">Curator List</span>
          <button mat-button color="primary" class="button-curratorList" (click)="viewAllCuratorList($event)">View All</button>
        </div>
        <table mat-table [dataSource]="curatorListDataSource" aria-label="curator list data">
          <ng-container matColumnDef="curator_name">
            <th mat-header-cell *matHeaderCellDef style="width: 30%;">Name</th>
            <td mat-cell *matCellDef="let row">
              <div class="ellipsis-text" title="{{row?.curator_name}}">{{ row?.curator_name }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef style="width: 25%;">Category
              <img src="assets/gamification-images/info-badge.svg" alt="info badge" class="info-badge" matTooltip="Latest category assigned to the Curator" style="cursor: pointer;"/>
            </th>
            <td mat-cell *matCellDef="let row">
              <span *ngIf="row.category?.length" style="display: flex;">
                <span class="single-line-ellipsis" title="{{ row?.category[0] }}">{{ row?.category[0] }}</span>
                <ng-container *ngIf="row.category.length > 1">
                  <span class="more-count" style="white-space: nowrap;" [matTooltip]="row.category.slice(1).join(', ')" matTooltipPosition="above">+{{ row?.category.length - 1 }}</span>
                </ng-container>
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="reviewed">
            <th class="text-ellipsis" title="Reviewed" mat-header-cell *matHeaderCellDef style="width: 15%;">Reviewed</th>
            <td mat-cell *matCellDef="let row">{{ row?.reviewed }}</td>
          </ng-container>
          <ng-container matColumnDef="approved">
            <th class="text-ellipsis" title="Approved" mat-header-cell *matHeaderCellDef style="width: 15%;">Approved</th>
            <td mat-cell *matCellDef="let row">{{ row?.approved }}</td>
          </ng-container>
          <ng-container matColumnDef="rejected">
            <th class="text-ellipsis" title="Rejected" mat-header-cell *matHeaderCellDef style="width: 15%;">Rejected</th>
            <td mat-cell *matCellDef="let row">{{ row?.rejected }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedCuratorListColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedCuratorListColumns;">
        </table>
      </mat-card>
      <!-- Top 3 Users -->
        <div class="data-table-card complex">
          <div class="complex-inner">
      <mat-card class="data-table-card user-card" *ngIf="topUserList?.length">
        <div class="table-header back-white">
          <div style="display: flex;align-items: center;gap:4px; ">
          <span ><img src="assets/icons/Trophy_Cup.svg" alt="Tropy cup" class=""/></span>
          <span class="table-title"> Top 3 Users</span>
          </div>
          <div class="btn-container">
          <button class="top-btn"  (click)="previous('user')" [disabled]="currentIndex === 0"><img *ngIf="currentIndex > 0" src="assets/icons/Active_arrow_back.svg" alt="previous"/><img *ngIf="currentIndex === 0" src="assets/icons/Disabled_arrow_back.svg" alt="previous"/></button>
          <span style="margin: 0 1rem;">
            <b>{{ currentIndex + 1 }}</b> / {{ totalItems }}
          </span>
          <button class="top-btn" (click)="next('user')" [disabled]="currentIndex === topUserList.length - 1"><img *ngIf="currentIndex < (topUserList.length - 1)" src="assets/icons/Active_arrow_forward.svg" alt="forward" /><img *ngIf="currentIndex === topUserList.length - 1" src="assets/icons/Disabled_arrow_forward.svg" alt="forward" /></button>
        </div>
        </div>
        <div class="table-container">
          <div class="card-user">
            <div class="user-crown">
            <div class="avatar-wrapper">  
              @if(Top_user.rank==1){<img src="assets/icons/Crown-Gold.svg" alt="Tropy cup" class="crown-icon" />}
              @else if(Top_user.rank==2){<img src="assets/icons/Crown-Silver.svg" alt="Tropy cup" class="crown-icon" />}
              @else if(Top_user.rank==3){<img src="assets/icons/Crown-Bronze.svg" alt="Tropy cup" class="crown-icon" />} 
            <div class="user-avatar">
              <div><img src="assets/icons/icon-left.png" alt="user" class=""/>
              </div> 
            </div>
            </div>
            </div>
            <div class="user-details"><div>{{Top_user.username}}</div>
            <div>
              @if(Top_user.rank==1){<img src="assets/icons/_rank-1.svg" alt="Gold medal" class="medal-icon" />}
              @else if(Top_user.rank==2){<img src="assets/icons/_rank-2.svg" alt="Silver medal" class="medal-icon" />}
              @else if(Top_user.rank==3){<img src="assets/icons/_rank-3.svg" alt="Bronze medal" class="medal-icon" />}
            </div>
        </div>
        
        </div>
        <div class="Frame-172885">
          <div class="data"> <img src="assets/icons/terminalNew.svg" alt="terminal" class="medal-icon" />&nbsp; {{Top_user.total_prompts_used}} Runs</div>
          <div class="divider"></div>
          <div class="data"> <img src="assets/icons/profile-star.svg" alt="profile-star" class="medal-icon" />&nbsp;{{Top_user.total_ratings_provided}} Ratings Provided</div>
          <div class="divider"></div>
          <div class="data"> <img src="assets/icons/rewarded-ads.svg" alt="rewarded-ads" class="medal-icon" />&nbsp;{{Top_user.points}} Points</div>

        </div>

        </div>
      </mat-card>

      <!-- Top 3 Creators -->
      <mat-card  class="data-table-card user-card" *ngIf="topCreatorList?.length">
        <div class="table-header back-white">
          <div style="display: flex;align-items: center;gap:4px; ">
          <span ><img src="assets/icons/Trophy_Cup.svg" alt="Tropy cup" class=""/></span>
          <span class="table-title"> Top 3 Creators</span>
          </div>
          <div class="btn-container">
          <button class="top-btn"  (click)="previous('creator')" [disabled]="current_creator_Index === 0"><img *ngIf="current_creator_Index > 0" src="assets/icons/Active_arrow_back.svg" alt="previous"/><img *ngIf="current_creator_Index === 0" src="assets/icons/Disabled_arrow_back.svg" alt="previous"/></button>
          <span style="margin: 0 1rem;">
            <b>{{ current_creator_Index + 1 }}</b> / {{ total_creator_Items }}
          </span>
          <button class="top-btn" (click)="next('creator')" [disabled]="current_creator_Index === topCreatorList.length - 1"><img *ngIf="current_creator_Index < (topCreatorList.length - 1)" src="assets/icons/Active_arrow_forward.svg" alt="forward" /><img *ngIf="current_creator_Index === topCreatorList.length - 1" src="assets/icons/Disabled_arrow_forward.svg" alt="forward" /></button>
        </div>
        </div>
        <div class="table-container">
          <div class="card-user">
            <div class="user-crown">
            <div class="avatar-wrapper">  
              @if(Top_creator.rank==1){<img src="assets/icons/Crown-Gold.svg" alt="Tropy cup" class="crown-icon" />}
              @else if(Top_creator.rank==2){<img src="assets/icons/Crown-Silver.svg" alt="Tropy cup" class="crown-icon" />}
              @else if(Top_creator.rank==3){<img src="assets/icons/Crown-Bronze.svg" alt="Tropy cup" class="crown-icon" />} 
            <div class="user-avatar">
              <div><img src="assets/icons/icon-left.png" alt="user" class=""/>
              </div> 
            </div>
            </div>
            </div>
            <div class="user-details"><div>{{Top_creator.username}}</div> 
            <div>
              @if(Top_creator.rank==1){<img src="assets/icons/_rank-1.svg" alt="Gold medal" class="medal-icon" />}
              @else if(Top_creator.rank==2){<img src="assets/icons/_rank-2.svg" alt="Silver medal" class="medal-icon" />}
              @else if(Top_creator.rank==3){<img src="assets/icons/_rank-3.svg" alt="Bronze medal" class="medal-icon" />}
            </div>
        </div>
        </div>
        <div class="Frame-172885" style="gap:8px;">
          <div class="data"> <img src="assets/icons/terminalNew.svg" alt="terminal" class="medal-icon" />&nbsp; {{Top_creator.total_prompts_created}} Prompts Published</div>
          <div class="divider"></div>
          <div class="data"> <img src="assets/icons/star-half.svg" alt="star-half" class="medal-icon" />&nbsp;{{Top_creator.average_rating}} Avg. Rating Received</div>
          <div class="divider"></div>
          <div class="data"> <img src="assets/icons/rewarded-ads.svg" alt="rewarded-ads" class="medal-icon" />&nbsp;{{Top_creator.points}} Points</div>

        </div>

        </div>
      </mat-card>
    </div>
  </div>
    </div>
  </div>
 

@if(isLoading){
  <app-loader></app-loader>
  }
